import React from 'react';
import PropTypes from 'prop-types';
import OutsideClickHandler from 'react-outside-click-handler';
import { defineMessages, injectIntl, useIntl } from 'react-intl';
import DataCacheService from '@/shared/services/DataCacheService';
import UserSearch, { getUserIdFromValue, userShape } from '@/shared/components/input/UserSearch';
import intlShape from '@/shared/utils/intlShape';
import EditableToggle from './EditableToggle';

const messages = defineMessages({ Unassigned: 'Unassigned' });

const EditableUserSearch = ({
  onChange,
  value,
  disabled,
  submitOnChange,
  intl,
  className,
  withUnassigned,
  unassignedId,
  includeInactiveUsers,
  ...rest
}) => {
  const userId = getUserIdFromValue(value);

  return (
    <EditableToggle
      onSubmit={onChange}
      value={value}
      disabled={disabled}
      displayValue={
        userId ? DataCacheService.getUserName(userId) : intl.formatMessage(messages.Unassigned)
      }
      className={className}
    >
      {({ inputValue, setInputValue, submit, handleKeyDown }) => (
        <OutsideClickHandler onOutsideClick={submit}>
          <UserSearch
            hideClearButton
            {...rest}
            value={inputValue}
            emptyLabel={intl.formatMessage(messages.Unassigned)}
            onChange={e => {
              if (submitOnChange && !!e) {
                setInputValue(e).then(submit);
              } else {
                setInputValue(e);
              }
            }}
            onKeyDown={handleKeyDown}
            withUnassigned={withUnassigned}
            unassignedId={unassignedId}
            includeInactiveUsers={includeInactiveUsers}
          />
        </OutsideClickHandler>
      )}
    </EditableToggle>
  );
};
EditableUserSearch.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([
    userShape,
    PropTypes.shape({ id: PropTypes.string.isRequired }),
    PropTypes.string,
  ]),
  disabled: PropTypes.bool,
  submitOnChange: PropTypes.bool,
  withUnassigned: PropTypes.bool,
  unassignedId: PropTypes.string,
  intl: intlShape.isRequired,
  className: PropTypes.string,
  includeInactiveUsers: PropTypes.bool,
};

EditableUserSearch.defaultProps = {
  value: null,
  disabled: false,
  submitOnChange: false,
  withUnassigned: false,
  className: '',
  unassignedId: '',
  includeInactiveUsers: false,
};

export default injectIntl(EditableUserSearch);
